var col = 'y0armh5 y0armh2';
var fill = 'y0armh6';
var row = 'y0armh4 y0armh2';
var spacer = 'y0armh3';
var wrapVar = '--y0armh0';

export { col, fill, row, spacer, wrapVar };
//# sourceMappingURL=stack.css.js.map
